import {ActionBarBehavior} from "../action-bar-behavior";
import {Router} from "@angular/router";
import {ActionBarConfig} from "../../../../model/action-bar-config";
import * as _ from 'lodash';
import {OnDestroy, Injectable} from "@angular/core";
import {BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {Subject, Subscription} from "rxjs/Rx";
import {takeUntil} from 'rxjs/operators';
import { CustomActionEvent } from '../../service/custom-action-event';
import { ActionBarService } from 'src/shared/service/action-bar.service';
import { ActionBarType } from 'src/shared/constants/action-bar-type.enum';
import { ActionBarAction } from 'src/shared/constants/action-bar.action';
import { CustomActionBarTypeEnum } from 'src/shared/constants/custom-action-bar-type.enum';

@Injectable()
export class NewActionBarBehavior extends ActionBarBehavior implements OnDestroy {

  ngUnsubscribe: Subject<boolean> = new Subject<boolean>();
  subscriptions: Subscription[] = [];

  config: ModalOptions = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  constructor(
    private router: Router,
    private dialogService: BsModalService,
    private csCustomAction: CustomActionEvent,
    private csEventService: ActionBarService
  ) {
    super();
  }

  isActionBar(type: ActionBarType): boolean {
    return ActionBarType.NEW === type;
  }

  executeAction(
    actionBarConfig: ActionBarConfig, selectedRecords: any[], additionalParams: any
  ) {
    const actionNewConfig = _.find(actionBarConfig.buttonBarConfigs, conf => conf.actionBarType === ActionBarType.NEW);
    if (actionNewConfig && actionNewConfig.routerPage) {
      this.router.navigate([actionNewConfig.routerPage.routerLink]);
    } else if (actionNewConfig && actionNewConfig.customAction) {
      this.csEventService.emitChange(ActionBarAction.NEW);
      this.csCustomAction.emitChange({type: CustomActionBarTypeEnum.NEW, value: true, actionId: additionalParams.actionId});
    } else {
      // custom default
      const bsModalRef = this.dialogService.show(actionBarConfig.addNewForm,
        { ...this.config, initialState: actionBarConfig.initState });
      bsModalRef.setClass(actionNewConfig.customClass ? actionNewConfig.customClass : `modal-dialog-right ${additionalParams.customModal}`);
      this.subscriptions.push(this.dialogService.onHide.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
        if (bsModalRef.content.submit) {
          this.csCustomAction.emitChange({type: CustomActionBarTypeEnum.REFRESH, value: true, actionId: additionalParams.actionId});
        }
        this.unsubscribe();
      }));

      if (bsModalRef.content && bsModalRef.content.saveNewChange) {
        bsModalRef.content.saveNewChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
          this.csCustomAction.emitChange({type: CustomActionBarTypeEnum.REFRESH, value: true, actionId: additionalParams.actionId});
          this.unsubscribe();
        });
      }
    }
  }

  unsubscribe() {
    _.forEach(this.subscriptions, (subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.unsubscribe();
  }
}
